const actionTypes = {
    SET_TOKEN: 'SET_TOKEN',
    GET_TOKEN: 'GET_TOKEN',
    UNSET_TOKEN: 'UNSET_TOKEN',
    SET_PROFILE: 'SET_PROFILE',
    UNSET_PROFILE: 'UNSET_PROFILE' 
}

export {actionTypes};